import { useState, useContext, useCallback, useMemo, useEffect, useRef } from 'react';
import { DrawerContext } from 'src/mtska-frontend-app-component/components/Drawer/DrawerContext';
import { SettingsContext } from 'src/mtska-frontend-app-scaffolding'
import { useDebounce } from 'src/mtska-frontend-app-scaffolding/hooks/useDebounce';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

// USATO PER ESPORRE I SETTINGS ALLE COMPONENTI CORE
export const useAppSettingsContext = () => {
    const { settings, settingsLoaded, setSettings, saveSettings } = useContext(SettingsContext);

    // usato da LegalEntitySelect che imposta la chiave di primo livello "selectedLegalEntity" con {id} della le 
    const setSettingsKey = (modelKey, newModelSettings) => {
        // 1) PERSISTO LO STATO NEL SettingsContext
        //    Il SettingsContext vuole l'intero oggetto settings, composto da tutti i moduli
        const newSettings = { ...settings, [modelKey]: newModelSettings };
        console.info("useAppSettingsContext:setSettingsProxy persisto lo stato di settings in SettingsContext:", modelKey, newSettings, Date.now());
        setSettings(newSettings);

        // 2) SALVO LE MODIFICHE DI PREFERENZE UTENTE A DB
        //    Il salvataggio vuole solo i settings del modello corrente
        console.info("useAppSettingsContext:setSettingsProxy Salvo settings:", modelKey, newModelSettings, Date.now());
        saveSettings({ canReloadCounter: false, name: modelKey, value: newModelSettings })
    };

    return useMemo(() => ({
        settings,
        settingsLoaded,
        setSettingsKey
    }), [
        settings,
        settingsLoaded,
        setSettingsKey
    ]);
}

// USATO PER ESPORRE I SETTINGS ALLE COMPONENTI SUPERFICIALI
export const useSettingContextInComponent = (dataProviderName, defaultFilters) => {
    const { isInsideDrawer } = useContext(DrawerContext);
    //console.info('useSettingContextInComponent:isInsideDrawer', isInsideDrawer());
    //console.info('°1°°°ACCEDO CON GARBO E ELEGANZA ALLO useSettingContextInComponent', dataProviderName, defaultFilters);
    const [drawable, setDrawable] = useState(false);
    const [filterModel, setFilterModel] = useState();
    const [visibilityModel, setVisibilityModel] = useState();
    const [safeDefaultFilters, setSafeDefaultFilters] = useState({ items: [] });
    const [isDrawer, setIsDrawer] = useState(() => isInsideDrawer());
    const { settings, settingsLoaded, mergeGlobalAndLocalFilters, addKeyToFilterModel } = useSettingsContext(dataProviderName);

    const previousLocalDefaultFiltersRef = useRef();

    useEffect(() => {
        if (JSON.stringify(previousLocalDefaultFiltersRef.current) !== JSON.stringify(defaultFilters)) {
            previousLocalDefaultFiltersRef.current = defaultFilters;
            const isValidDefaultFilters = (defaultFilters) => {
                if (!defaultFilters) {
                    return false;
                }
                if (typeof defaultFilters !== 'object') {
                    return false;
                }
                if (!Array.isArray(defaultFilters?.items ?? null)) {
                    return false;
                }

                return true;
            };

            if (!isValidDefaultFilters(defaultFilters)) {
                //console.info('°2°°°IMPOSTO CON SENSIBILITÀ E DEVOZIONE SAFE FILTER MODEL vuoto', { items: [] });
                // defaultFilters non è valido, usa valore di default
                setSafeDefaultFilters({ items: [] });
            } else {
                //console.info('°2°°°IMPOSTO CON SENSIBILITÀ E DEVOZIONE SAFE FILTER MODEL defaultFilters', defaultFilters);
                setSafeDefaultFilters(defaultFilters)
            }
        }
    }, [defaultFilters]);

    useEffect(() => {
        if (!settings || !settingsLoaded) return;

        // Usare sempre `defaultFilters` del render corrente quando validi: `safeDefaultFilters` è aggiornato in un
        // altro useEffect e può restare un frame (o più) indietro rispetto a `settings` dopo replaceFilters → merge
        // riapplicava filtri rimossi (es. Area "Tutte" dopo un'area singola in BI / dashboard).
        const defaultFiltersValid =
            defaultFilters &&
            typeof defaultFilters === 'object' &&
            Array.isArray(defaultFilters.items);

        if (!defaultFiltersValid && !safeDefaultFilters) return;

        const externalForMerge = defaultFiltersValid ? defaultFilters : safeDefaultFilters;

        let fm;
        if (!isDrawer) {
            // se non sono in un drawer, faccio il merge tra filtri globali e quelli passati eventualmente alla lista
            //console.info('°3°°°SCELGO CON GIUOIA LA STRADA NON DRAWER', {...safeDefaultFilters})
            fm = addKeyToFilterModel(mergeGlobalAndLocalFilters(externalForMerge));
        } else {
            //console.info('°3°°°SCELGO CON LETIZIA LA STRADA DRAWER', {...safeDefaultFilters})
            // se sono in un drawer i filtri sono solo quelli locali
            fm = addKeyToFilterModel(externalForMerge);
        }

        setFilterModel(fm);
        //console.info('°4°°°ESEGUO CON GRAZIA IL SETTAGGIO DI filterModel', dataProviderName, isDrawer, 'safeDefaultFilters', safeDefaultFilters, 'defaultFilters',  defaultFilters, 'filterModel', fm )
        setVisibilityModel(settings.visibilityModel);
        setDrawable(true);
    }, [settings, settingsLoaded, defaultFilters, safeDefaultFilters, isDrawer]);

    return useMemo(() => ({
        drawable,
        filterModel,
        visibilityModel,
        settingsLoaded
    }), [
        drawable,
        filterModel
    ]);
}

export const useSettingsContext = (dataProviderName, defaultFilters) => {
    const { settings, settingsLoaded, setSettings, saveSettings, hello } = useContext(SettingsContext);
    const { item: config } = useDataProvider('configs/config');

    useEffect(() => {
        // console.info('QUESTO DEVE ESSERE IL QUARTO +++++useSettingsContext:useEffect[settings] Settings AGGIORNATI:', settings, 'caricati', settingsLoaded, Date.now());
    }, [settings]);

    // 1. getDefaultModel: Recupera da config il settings default se settings non esiste
    const getDefaultModel = useCallback(() => {
        const { tableConfig = {} } = config?.data?.modules[dataProviderName] || {};
        const { columns: columnOrder, columnVisibilityModel: visibilityModel } = tableConfig;
        return { columnOrder, paginationModel: { page: 0, pageSize: 20 }, visibilityModel };
    }, [config, dataProviderName]);

    // 2. getModelSettings: valuta se è necessario recuperare i settings di default
    const modelSettings = useMemo(() => {
        if (dataProviderName && settingsLoaded) {
            const modelSettings = settings[`${dataProviderName}.model`];
            // console.info('QUESTO DEVE ESSERE IL QUINTO +++++useSettingsContext:modelSettings modelSettings.filterModel RICEVUTI:', modelSettings?.filterModel, Date.now());
            if (modelSettings === undefined) {
                return getDefaultModel();
            } else {
                return modelSettings;
            }
        }
    }, [dataProviderName, settings]);

    // 3. Persistenza server debounced: lo stato React si aggiorna subito in setSettingsKey così
    //    liste/grafici (es. Pie dashboard) non ricevono filterModel ritardato rispetto a addFilter.
    const debouncedSaveModelSettings = useCallback(
        useDebounce(
            [
                {
                    callback: (payload) => {
                        saveSettings(payload);
                    },
                },
            ],
            400,
        ),
        [saveSettings],
    );

    // 4. setSettingsKey, sostituisce una chiave dentro ai settings di modulo ()
    const setSettingsKey = useCallback(
        (key, value) => {
            const modelKey = `${dataProviderName}.model`;
            setSettings((prev) => {
                const prevModel = prev[modelKey] ?? getDefaultModel();
                const newModelSettings = { ...prevModel, [key]: value };
                const newFull = { ...prev, [modelKey]: newModelSettings };
                debouncedSaveModelSettings({
                    canReloadCounter: false,
                    name: modelKey,
                    value: newModelSettings,
                });
                return newFull;
            });
        },
        [dataProviderName, getDefaultModel, setSettings, debouncedSaveModelSettings],
    );

    const filterActions = useFiltersSettings(
        modelSettings,
        setSettingsKey,
        settingsLoaded
    );

    return useMemo(() => ({
        settings: modelSettings,
        settingsLoaded,
        setSettingsKey,
        getDefaultModel,

        addFilter: filterActions.addFilter,
        addFilters: filterActions.addFilters,
        editFilter: filterActions.editFilter,
        removeFilter: filterActions.removeFilter,
        emptyFilters: filterActions.emptyFilters,
        replaceFilters: filterActions.replaceFilters,
        cleanFilters: filterActions.cleanFilters,
        comparableFilters: filterActions.comparableFilters,
        mergeFilters: filterActions.mergeFilters,
        mergeGlobalAndLocalFilters: filterActions.mergeGlobalAndLocalFilters,
        addKeyToFilterModel: filterActions.addKeyToFilterModel
    }), [
        modelSettings,
        settingsLoaded,
        setSettingsKey,
        getDefaultModel,
        filterActions
    ]);
};

const useFiltersSettings = (settings, setSettingsKey, settingsLoaded) => {
    return useMemo(() => {
    const mergeFilters = (k, v, operator = 'equals', id, container, keepExisting = false) => {
        const newFilterModel = { items: [...(container?.items ?? [])] };
        const existingIndex = newFilterModel.items.findIndex(item => item.field === k);

        if ((v === undefined || v === "" || v === null) && existingIndex !== -1 && !['isEmpty', 'isNotEmpty'].includes(operator)) {
            // se passo un valore vuoto e ho il filtro sul campo, elimino
            newFilterModel.items.splice(existingIndex, 1);
        } else if (existingIndex !== -1 && newFilterModel.items[existingIndex].value === v) {
            // se passo lo stesso valore e ho il filtro sul campo, elimino

            // non ricordo perché sbianchiamo se riceviamo lo stesso valore. Per ora condiziono poi vedremo
            const deleteIfEqual = false;
            if (deleteIfEqual) {
                newFilterModel.items.splice(existingIndex, 1);
            }
        } else if (existingIndex !== -1 && !keepExisting) {
            // se passo un nuovo valore e ho il filtro sul campo, aggiorno
            newFilterModel.items[existingIndex].value = v;
            newFilterModel.items[existingIndex].operator = operator;
            newFilterModel.items[existingIndex].id = id;
        } else if (existingIndex === -1 && v !== undefined) {
            // se passo un nuovo valore e non ho il filtro sul campo, aggiungo
            newFilterModel.items.push({
                field: k,
                operator: operator,
                value: v,
                id: id
            });
        }
        //console.info('useSettingContext::useFilterManager::mergeFilters', k, v, operator, newFilterModel);

        return newFilterModel;
    };

    // Usato dai componenti concreti che possono ricevere una prop "filters" per unire i filtri in settings con quelli locali
    // Fino a che l'utente, con un'azione sulla tabella, non staticizza a db, i dati rimangono volatili
    const mergeGlobalAndLocalFilters = (externalFilters) => {
        // usiamo il giro json perché { ...(settings?.filterModel ?? {}) }; mantiene i riferimenti interni 
        let newFilterModel = JSON.parse(JSON.stringify(settings?.filterModel ?? { items: [] }));
        const externalItems = externalFilters?.items ?? [];
        // Dimensioni dashboard spesso passate come prop `filters` che è in realtà il filterModel già mergiato
        // dal Container: dopo un clear in persistenza, quell'echo può restare un render con valore vecchio e
        // mergeFilters re-aggiungerebbe il campo. Se il campo non è in settings, non lo reintrodurre da external.
        const settingsFieldSet = new Set((settings?.filterModel?.items ?? []).map((i) => i.field));
        const skipStaleExternalIfAbsentFromSettings = new Set([
            '_related_area_name',
            '_related_shop_name',
            '_related_shops_readable',
        ]);
        externalItems.forEach((item) => {
            if (
                skipStaleExternalIfAbsentFromSettings.has(item.field) &&
                !settingsFieldSet.has(item.field)
            ) {
                return;
            }
            // keepExisting=false: i filtri passati dal parent (es. BI Integrated) devono sovrascrivere
            // i filtri persistiti del modulo (es. range data salvato su opportunities/lead).
            newFilterModel = mergeFilters(item.field, item.value, item.operator, item.id, newFilterModel, false)
        })

        if (settings?.filterModel?.quickFilterValues) {
            newFilterModel.quickFilterValues = settings?.filterModel?.quickFilterValues
        }

        //console.info('useFilterManager:mergeGlobalAndLocalFilters ricevuto externalFilters', externalFilters, ' risultato da inviare a List', newFilterModel, 'settings?.filterModel', settings?.filterModel)
        return newFilterModel;
    };

    const addFilters = (items) => {
        // usiamo il giro json perché { ...(settings?.filterModel ?? {}) }; mantiene i riferimenti interni 
        let newFilterModel = JSON.parse(JSON.stringify(settings?.filterModel ?? { items: [] }));
        items.forEach((item) => {
            newFilterModel = mergeFilters(item.field, item.value, item.operator, item.id, newFilterModel)
        })

        //console.info('useFilterManager:addFilters ricevuto items', items, ' risultato da sostituire tramite replaceFilters', newFilterModel)
        replaceFilters(newFilterModel);
    };

    const addFilter = (k, v, operator = 'equals') => {
        if (!settingsLoaded) return;

        let newFilterModel = JSON.parse(JSON.stringify(settings?.filterModel ?? { items: [] }));
        newFilterModel = mergeFilters(k, v, operator, Math.floor(Math.random() * 5000) + 12500, newFilterModel)

        replaceFilters(newFilterModel);
    };

    const editFilter = (k, v, operator = 'equals') => {
        if (!settingsLoaded) return;

        let newFilterModel = JSON.parse(JSON.stringify(settings?.filterModel ?? { items: [] }));
        const itemExists = newFilterModel.items.some(item => item.field === k);

        if (itemExists) {
            newFilterModel.items = newFilterModel.items.map(item =>
                item.field === k ? { ...item, value: v, operator } : item
            );
            replaceFilters(newFilterModel);
        } else {
            addFilter(k, v, operator);
        }
    };

    const removeFilter = (k) => {
        if (!settingsLoaded) return;

        let newFilterModel = JSON.parse(JSON.stringify(settings?.filterModel ?? { items: [] }));
        newFilterModel.items = newFilterModel.items.filter((item) => item.field !== k);

        replaceFilters(newFilterModel);
    };

    const emptyFilters = () => {
        if (!settingsLoaded) return;

        let newFilterModel = { items: [] };

        replaceFilters(newFilterModel);
    };

    // USATO PER SALVATAGGIO A DB
    // elimino solo gli item con valore vuoto
    const cleanFilters = (filterModel) => {
        const cleanfilters = {
            items: (filterModel?.items || [])
                .filter(item => {
                    const value = item.value;
                    if ((value == undefined || value == null || value === "") && !['isEmpty', 'isNotEmpty'].includes(item.operator)) return false;

                    if (typeof value === 'object' && value !== null) {
                        if (Array.isArray(value)) {
                            if (['isEmpty', 'isNotEmpty'].includes(item.operator)) return true;
                            return value.length > 0;
                        }
                        const fromEmpty = value.from === undefined || value.from === null || value.from === "";
                        const toEmpty = value.to === undefined || value.to === null || value.to === "";
                        return !(fromEmpty && toEmpty);
                    }
                    return true;
                }),
        }

        if (filterModel?.quickFilterValues) {
            cleanfilters.quickFilterValues = filterModel?.quickFilterValues
        }

        return cleanfilters;
    };

    // USATO PER VERIFICA IN RUNTIME DELL'EGUAGLIANZA DI DUE filterModel
    // elimino le chiavi id, fromInput dal filter
    const comparableFilters = (filterModel) => {
        const comparablefilters = {
            items: cleanFilters(filterModel).items
                .map(({ id, fromInput, ...rest }) => rest)
        }

        if (filterModel?.quickFilterValues) {
            comparablefilters.quickFilterValues = filterModel?.quickFilterValues
        }

        return comparablefilters;
    };

    const replaceFilters = (newFilterModel) => {
        // Mettiamo in sicurezza
        if (Array.isArray(newFilterModel)) {
            newFilterModel = { items: [...(newFilterModel ?? [])] };
        }

        const _oldFilterModel = comparableFilters(settings.filterModel);
        const _newFilterModel = comparableFilters(newFilterModel);

        if (JSON.stringify(_oldFilterModel) != JSON.stringify(_newFilterModel)) {
            //pushToHistory(newFilterModel);
            //console.info('useFilterManager:replaceFilters impostabile', newFilterModel)
            setSettingsKey('filterModel', cleanFilters(newFilterModel));
            //console.info('useFilterManager:replaceFilters impostato', newFilterModel)
            // } else {
            //     console.info('useFilterManager:replaceFilters evito di sovrascrivere perché uguali', newFilterModel)
        } else {
            //console.info('useFilterManager:replaceFilters NON impostato', newFilterModel, _oldFilterModel, _newFilterModel)
        }
    }

    const pushToHistory = (filterModel) => {
        const qs = new URLSearchParams();
        filterModel.items.forEach(filter => {
            if (filter.value !== null && filter.value !== undefined) {
                qs.set(filter.field, (typeof filter.value === 'object') ? JSON.stringify(filter.value) : filter.value);
            }
        });
        const newUrl = `${window.location.pathname}?${qs.toString()}`;
        window.history.pushState(null, '', newUrl);
    }

    const addKeyToFilterModel = (filterModel) => {
        if (!filterModel?.items) return filterModel;

        return {
            ...filterModel,
            items: filterModel.items.map((item, index) => ({
                ...item,
                id: item.id || index + 1
            }))
        };
    };

    // const isValidJSON = (data) => {
    //     if (typeof data === 'object' && data !== null) return true;
    //     if (typeof data !== 'string') return false;

    //     try {
    //         const parsed = JSON.parse(data);
    //         return typeof parsed === 'object' && parsed !== null;
    //     } catch (e) {
    //         return false;
    //     }
    // };

    // PER LEGGERE DA LOCATION DOBBIAMO RENDERE SETTINGS CONTEXT FIGLIO DI <Routes modules={appConfiguration.modules.active} /> in ContextualizedApps
    // const location = useLocation();
    // const getFiltersFromLocation = () => {
    //     const locationparams = new URLSearchParams(location.search);
    //     const params = {
    //         ...defaultFilters,
    //         ...Object.fromEntries(locationparams)
    //     };

    //     //console.info('useSettingContext::useFilterManager::useFiltersFromLocation', params);
    //     if (params.size === 0) return;

    //     const newFilterModel = { items: [] };
    //     Object.entries(params).forEach(([field, value]) => {
    //         const isJSON = isValidJSON(value);

    //         if (isJSON) {
    //             let v = value
    //             if (typeof v === 'string') {
    //                 v = JSON.parse(value);
    //             }

    //             let operator = 'betweenNumbers'

    //             if (typeof v?.from !== 'number') {
    //                 operator = 'between'
    //             }

    //             newFilterModel.items.push({
    //                 field,
    //                 operator: operator,
    //                 value: v,
    //             });
    //         } else if (value == 'null' || value == 'missing' || value == '_') {
    //             newFilterModel.items.push({
    //                 field,
    //                 operator: 'isEmpty',
    //                 value,
    //             });
    //         } else if (
    //             [
    //                 '_related_legalEntity_commercialCluster',
    //                 '_related_renter_name',
    //                 '_related_area_name',
    //                 '_related_shop_name',
    //                 '_related_agent_fullname',
    //                 '_related_source_name'
    //             ].includes(field)
    //         ) { // campi che devono avere equals
    //             newFilterModel.items.push({
    //                 field,
    //                 operator: 'equals',
    //                 value,
    //             });
    //         } else {
    //             newFilterModel.items.push({
    //                 field,
    //                 operator: 'contains',
    //                 value,
    //             });
    //         }
    //     });

    //     return newFilters;
    // }

        return {
            addFilter,
            addFilters,
            editFilter,
            removeFilter,
            emptyFilters,
            replaceFilters,
            cleanFilters,
            comparableFilters,
            mergeFilters,
            mergeGlobalAndLocalFilters,
            addKeyToFilterModel,
        };
    }, [settings, setSettingsKey, settingsLoaded]);
};

export default useFiltersSettings;
